import React, {Component, PropTypes} from 'react'
import {Row, Col, Tooltip, OverlayTrigger} from 'react-bootstrap'
import extract from '../../core/extract'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import i18n from '../i18n'
import style from './UserCard.less'

class UserCard extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    render() {
        const {user, onSubmit, ...others} = this.props

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const header = (
            <div className={style.header}>
                <div className={style.action}>
                    {user._links.find(linkFinder(['UpdateLogin', 'sendActivationEmailDemand'])) && (
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.updateLogin)}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'UpdateLogin')}>
                                <Icon icon='mailGear' size='xs' />
                            </a>
                        </OverlayTrigger>
                    )}
                    {user._links.find(linkFinder(['AssociateUserWithAgency', 'DissociateUserFromAgency'])) && (
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.associateDissociateAgencies)}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'AssociateDissociateUserFromAgency')}>
                                <Icon icon='agencyRefresh' size='xs' />
                            </a>
                        </OverlayTrigger>
                    )}
                    {user._links.find(linkFinder(['AssociateUserWithPatrimony', 'DissociateUserFromPatrimony'])) && (
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.associateDissociatePatrimonies)}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'AssociateDissociateUserFromPatrimony')}>
                                <Icon icon='patrimonyGear' size='xs' />
                            </a>
                        </OverlayTrigger>
                    )}
                    {user._links.find(linkFinder('configs')) && (
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.configs)}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'configs')}>
                                <Icon icon='gear' size='xs' />
                            </a>
                        </OverlayTrigger>
                    )}
                    {user._links.find(linkFinder(['UpdateUser', 'DisableUser', 'DowngradeExecutiveToPatrimonyManager'])) && (
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.updateUser)}>
                            <a
                                href=''
                                onClick={(e) => onSubmit(e, 'UpdateUser')}>
                                <Icon icon='pencil' size='xs' />
                            </a>
                        </OverlayTrigger>
                    )}
                </div>
                <div className={style.container}>
                    <h5>{extract(i18n.userTypeEnum, user.userType)}</h5>
                </div>
            </div>
        )

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                    {!user.isActive && (
                        <div className={style.status}>
                            <Icon icon='closed' size='sm' />
                        </div>
                    )}
                    <div className={style.label}>
                        <h5>> {user.firstName} {user.lastName}</h5>
                    </div>
                    <div className={style.label}>
                        <h5>> {i18n.email} <small>{user.login}</small></h5>
                    </div>
                </Card>
            </div>
        )
    }
}

export default UserCard


// WEBPACK FOOTER //
// ./lib/company/components/UserCard.js